import { OwaDate } from 'owa-datetime';
import addDays from 'owa-datetime/lib/owaDate/addDays';
import addHours from 'owa-datetime/lib/owaDate/addHours';
import now from 'owa-datetime/lib/userDate/now';
import startOfDay from 'owa-datetime/lib/owaDate/startOfDay';

/**
 * Retrieves the default reminder time to initialize in the reminder picker with.
 * @param nowToUse Reference now time for unit testing
 */
export default function getDefaultReminderDateTime(nowToUse: OwaDate): OwaDate {
    const nowDateTime = nowToUse ? nowToUse : now();
    const today = startOfDay(nowDateTime);
    const tomorrow = addDays(today, 1);
    const defaultReminderDateTime = addHours(tomorrow, 11);

    return defaultReminderDateTime;
}
